<template>
  <div class="info-from-module">
    <div
      v-if="receptionInfo && receptionInfo.child && receptionInfo.child[0]"
      class="item border-bottom-1px"
    >
      <label>{{ receptionInfo.child[0].fieldname }}</label>
      <div class="fieldvalue">
        <not-can-edit-item
          :data="receptionInfoNew.child[0]"
        />
      </div>
    </div>
    <div
      v-if="fromInfo"
      class="from-module"
    >
      <div class="item border-bottom-1px">
        <label>{{ newData.label }}</label>
        <not-can-edit-item :data="newData" />
      </div>
      <!-- 信息来源部分特殊处理 start -->
      <template v-if="currentFrom">
        <div
          v-for="(item) in newChild"
          :key="item.fieldkey"
          class="item"
        >
          <label>{{ item.label }}</label>
          <not-can-edit-item
            :data="item"
            class="fieldValue"
          />
        </div>
      </template>
    <!-- 信息来源部分特殊处理 end -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import MySelect from './../formItem/Select'
// import MyItem from './../formItem/Item'
import NotCanEditItem from '@/components/mobile/formItem/NotCanEdit'

export default {
  components: {
    // MySelect,
    NotCanEditItem
    // MyItem
  },
  data () {
    return {
      currentFrom: ''
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', [
      'fromInfo',
      'receptionInfo'
    ]),
    newData () {
      let data = JSON.parse(JSON.stringify(this.fromInfo))
      const { childObj = {} } = data || {}

      data.label = data.fieldname
      data.value = data.fieldvalue
      data.type = data.fieldtype

      data.options = []
      for (let k in childObj) {
        const item = childObj[k]
        data.options.push({
          id: item.id,
          name: item.fieldname
        })
      }
      // data.childObj = childObj
      return { ...data, childObj }
    },
    newChild () {
      const { newData = {} } = this
      const { childObj = {} } = newData
      let { child = [] } = childObj[this.currentFrom] || []
      child = child.filter(child => child.status !== -7 && child.isenable)
      for (let k in child) {
        const item = child[k]
        item.isedit = 0
        item.label = item.fieldname
        item.value = item.fieldvalue
        item.type = item.fieldtype
      }
      return child
    },
    receptionInfoNew () {
      const { receptionInfo = {} } = this
      const values = receptionInfo.child[0].fieldvalue
      let namesArr = []
      if (values.length > 0) {
        values.forEach(val => {
          this.filterName(namesArr, receptionInfo.child[0].options, val)
        })
      }
      receptionInfo.child[0].valuenames = namesArr
      return receptionInfo
    }
  },

  watch: {
    fromInfo: {
      handler (val) {
        const { fieldvalue = '', child = [] } = val || {}
        let currentItem = child.find(one => one.fieldkey === fieldvalue) || {}
        this.currentFrom = currentItem.id
        if (!this.currentFrom) {
          this.currentFrom = child[0] && child[0].id
        }
        val.fieldname = val.fromname
      },
      immediate: true,
      deep: true
    },
    currentFrom: {
      handler (val) {
        if (!this.fromInfo) return

        this.fromInfo.fieldvalue = val
        this.fromInfo.fieldtype = 'select'
      },
      immediate: true
    }
  },
  methods: {
    handleChangeFrom (val) {
      this.currentFrom = val
    },
    // 处理接待显示的name值
    filterName (namesArr, arr, id) {
      arr.forEach(item => {
        if (item.id === id) {
          namesArr.push(item.name)
        } else {
          if (item.children && item.children.length > 0) {
            this.filterName(namesArr, item.children, id)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-from-module {
  background-color: #fff;
  .item {
    display: flex;
    min-height: 56px;
    line-height: 56px;
    padding: 0 12px;
    label {
      width: 100px;
      min-height: 32px;
      line-height: 32px;
      padding: 12px 26px 12px 0;
      color: #888;
      word-break: break-all;
    }
    .fieldValue {
      flex: 1;
      width: 200px;
    }
  }
}
</style>
